import { BaseAppScript, TemplateVarsMap } from "./models";
import * as api from "./api";

import { UseLoading } from "@/common/composition/loading";
import { UseRef } from "@/common/composition/use-ref";
import "./mock/api.mock";
import { cloud_playbooks_state } from "../cloud-playbooks/data/state";
import { init_filters } from "./state.filters";
import { computed } from "@vue/composition-api";
import { SharedState } from "@/common/state";
import { once } from "@/fp";
import { UseTabs } from "@/common/composition/use-tabs";
import { UseDropdownItems } from "@/common/composition/dropdown-items";
import { state as data_sources_state } from "@/views/customize/data-sources/data/state";
const [tabs, selected_tab, set_selected_tab] = UseTabs(
  [
    { id: "playbooks", name: "Playbooks", icon: "Playbook" },
    { id: "audit", name: "Audit", icon: "Calendar", soon: true, disable: true },
  ],
  0
);

const { filters, filter, destroy_filters } = init_filters((f) => {
  console.log("filter has changed , need to process it", f);
});

const [
  data_sources,
  selected_source,
  set_selected_source,
  init_data_sources,
] = UseDropdownItems<{ id: string; name: string; icon: string }>([]);

const [template_vars, set_template_vars] = UseRef<TemplateVarsMap>({});
const [scripts, set_scripts] = UseRef<BaseAppScript[]>([]);

const filtered_scripts = computed(() => filter([...scripts.value]));

const load_template_vars_map = async () => {
  const res = await api.get_template_vars_map();
  if (res.success) {
    set_template_vars({
      ...res.value,
      "{~label}": Object.values(SharedState.allInfoTypes.value).map((f) => ({
        id: f.id,
        name: f.labelName,
      })),
    });
  }
};
//is_not_licensed

const set_script_licensing_status = (
  scripts: BaseAppScript[]
): BaseAppScript[] => {
  return scripts.map((d) => {
    if (d.type == "policy") {
      d.is_not_licensed = !SharedState.FeatureHelper.is_enabled(
        "justification_automation"
      );
    }
    if (["mpip", "a88991f2-de84-434c-a575-0d32a788366d"].includes(d.id)) {
      d.is_not_licensed = !SharedState.FeatureHelper.is_enabled(
        "auto_mip_labeling"
      );
    }
    return d;
  });
};

const load_scripts = async () => {
  await cloud_playbooks_state.init();
  const res = await api.get_all_scripts();
  if (res.success) {
    const all_scripts = set_script_licensing_status([
      ...res.value,
      ...cloud_playbooks_state.scripts.value,
    ]);
    set_scripts(all_scripts);
  }
};

const [is_loading, set_loading] = UseLoading(false).as_arr();

const should_mock = () => SharedState.env.value.env == "uat";

const init = once(async () => {
  set_loading(true);
  if (should_mock()) {
    console.log("SET AS MOCK");
    // @ts-ignore
    window.toggle_mock(true);
  }
  await data_sources_state.init();
  await load_template_vars_map();
  await load_scripts();
  init_data_sources([
    {
      id: "all",
      name: "All",
      icon: "All",
    },
    ...data_sources_state.all_sources.value
      .filter((f) => f.runtime.enabled)
      .map((s) => {
        return {
          id: s.id,
          name: s.name,
          icon: s.runtime.icon,
        };
      }),
  ]);
  set_selected_source(data_sources.value[0].id);
  filters.threat.update([...scripts.value]);
  filters.group.update([...scripts.value]);
  set_loading(false);
});

export const state = {
  init,
  tabs,
  data_sources,
  selected_source,
  set_selected_source,
  selected_tab,
  set_selected_tab,
  is_loading,
  template_vars,
  scripts: filtered_scripts,
  filters,
  on_destroy: () => {
    destroy_filters();
    if (should_mock()) {
      console.log("REMOVE MOCK");
      // @ts-ignore
      window.toggle_mock(false);
    }
  },
};
